// Do not edit.
import { ShaderStore } from "../../Engines/shaderStore.js";
var name = "meshVertexDeclaration";
var shader = "uniform mat4 world;\nuniform float visibility;\n";
// Sideeffect
ShaderStore.IncludesShadersStore[name] = shader;
/** @hidden */
export var meshVertexDeclaration = { name: name, shader: shader };
//# sourceMappingURL=meshVertexDeclaration.js.map